export const getArgentinaData = () => ({
  name: "Argentine",
  description: "L'Argentine est le plus grand producteur de vin d'Amérique du Sud, réputée pour ses vins de Malbec puissants et fruités. Le pays bénéficie d'un climat continental unique avec des vignobles en altitude dans les Andes, produisant des vins avec une personnalité distincte et une excellente qualité.",
  type: "country",
  regions: [
    { name: "Mendoza", area: "150,000 ha", percentage: "70%", description: "Cœur viticole de l'Argentine" },
    { name: "Patagonie", area: "15,000 ha", percentage: "7%", description: "Vins frais et élégants" },
    { name: "Salta", area: "12,000 ha", percentage: "6%", description: "Vins d'altitude" },
    { name: "San Juan", area: "18,000 ha", percentage: "8%", description: "Vins de qualité" },
    { name: "La Rioja", area: "8,000 ha", percentage: "4%", description: "Plus ancienne région" },
    { name: "Autres", area: "12,000 ha", percentage: "5%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Mendoza", x: -68.5, y: -32.5, color: "#4B164C", size: 8 },
    { region: "Patagonie", x: -68.0, y: -40.0, color: "#6d2c7a", size: 4 },
    { region: "Salta", x: -65.5, y: -24.5, color: "#8a4a8a", size: 3 },
    { region: "San Juan", x: -68.0, y: -31.0, color: "#a768a6", size: 4 },
    { region: "La Rioja", x: -66.5, y: -29.0, color: "#c486c4", size: 3 }
  ],
  statistics: {
    totalArea: "215,000 ha",
    production: "12 million hectolitres",
    regions: "6 régions principales",
    appellations: "25+ appellations",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Climat continental avec influences andines, étés chauds et secs",
    soil: "Sols alluviaux, calcaires, sableux, excellente drainage",
    viticulture: "Vignobles en altitude, irrigation contrôlée, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges puissants et fruités, avec des tanins mûrs et une excellente concentration",
    white: "Vins blancs frais et aromatiques, avec une belle acidité naturelle",
    rosé: "Rosés fruités et accessibles, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle et Charmat"
  },
  history: "La viticulture argentine remonte à l'arrivée des conquistadors espagnols au XVIe siècle. Les missionnaires jésuites ont développé les premiers vignobles. L'immigration italienne au XIXe siècle a apporté de nouvelles techniques et cépages. Le Malbec, originaire de France, est devenu le cépage emblématique de l'Argentine. Aujourd'hui, l'Argentine est reconnue mondialement pour la qualité de ses vins.",
  foodPairing: "Cuisine argentine traditionnelle : asado (barbecue), empanadas, locro, dulce de leche. Les vins argentins s'accordent parfaitement avec les viandes rouges, les fromages affinés et la gastronomie internationale."
}); 